import React, {useState} from "react";
import { Button, Control, Field, Input } from "@allxsmith/bestax-bulma";
import axios from "axios";
import {createSetDataFreshAction} from "../../../actions/dataActions";
import {useDispatch} from "react-redux";
import {ToastContainer, toast} from "react-toastify";


export default function RentalMarginRow({marginData, index, onUpdate, dataFresh}){
    const dispatch = useDispatch();
    const [margin, setMargin] = useState(marginData);
    const [editable, setEditable] = useState(false);

    const onEdit = e => {
        e.stopPropagation();
        setEditable(!editable);
    };

    const onChange = (e) => {
        let newRentalMargin = {...margin};
        newRentalMargin[e.target.name] = e.target.value || null;
        setMargin(newRentalMargin);
        onUpdate(index, newRentalMargin);
    }

    const submitUpdate = (e) => {
        e.stopPropagation();
        const conf = {
            method: "put",
            data: margin,
            url: "api/rentalmargin/"+margin.id
        }
        axios(conf).then(res => {
           setEditable(false);
           dispatch(createSetDataFreshAction(dataFresh + 1))
        })
    }

    const onDelete = () => {
        const conf = {
            method: "delete",
            url: "api/rentalmargin/"+margin.id
        }
        axios(conf).then(() => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            if(err){
                toast.error("There was an error", {position: "top-right"});
            }
        })
    }

    return (
        <tr>
            <td>
                <Field onClick={e => e.stopPropagation()} className="has-addons">
                    <Control>
                        <Input
                          type={"text"}
                          name={"name"}
                          value={margin.name}
                          disabled={!editable}
                          onChange={onChange}
                        />
                    </Control>
                    {editable ? (
                      <Control>
                          <Button color="success" onClick={submitUpdate}>
                              Save
                          </Button>
                      </Control>
                    ) : (
                      <Control>
                          <Button onClick={onEdit}>Edit</Button>
                      </Control>
                    )}

                </Field>
            </td>
            <td>
                <Field onClick={e => e.stopPropagation()} className="has-addons">
                    <Control>
                        <Input
                          type={"text"}
                          name={"margin"}
                          value={margin.margin}
                          disabled={!editable}
                          onChange={onChange}
                        />
                    </Control>
                    {editable ? (
                      <Control>
                          <Button color="success" onClick={submitUpdate}>
                              Save
                          </Button>
                      </Control>
                    ) : (
                      <Control>
                          <Button onClick={onEdit}>Edit</Button>
                      </Control>
                    )}

                </Field>
            </td>
            <td>
                <Button
                  color={"danger"}
                  onClick={onDelete}
                >
                    Delete X
                </Button>
            </td>
        </tr>
    );

}